import useSyncedStorageState from 'hooks/useSyncedStorageState';
import { POST_ADD_TO_CART_POPUP_STORAGE_KEY } from './constants';
import { useCallback, useEffect, useState } from 'react';

interface PostAddToCartPopupOptions {
  isNewUser?: boolean;
  cartQuantity?: number;
}

interface PostAddToCartPopupState {
  popupTriggered: boolean;
  dismissed: boolean;
}

const defaultState: PostAddToCartPopupState = {
  popupTriggered: false,
  dismissed: false,
};

const usePostAddToCartPopup = ({
  cartQuantity,
  isNewUser,
}: PostAddToCartPopupOptions = {}) => {
  const { state, update, hydrated } = useSyncedStorageState(
    POST_ADD_TO_CART_POPUP_STORAGE_KEY,
    defaultState,
    {
      channel: 'post-add-to-cart-popup',
      lockKey: 'post-add-to-cart-popup-lock',
    },
  );

  const [showPopup, setShowPopup] = useState(false);

  const triggerPopup = useCallback(() => {
    if (!hydrated || state.dismissed) return;
    update((prev) => ({ ...prev, popupTriggered: true }));
  }, [hydrated, state, update]);

  useEffect(() => {
    if (state.popupTriggered && !state.dismissed && isNewUser) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isNewUser, state.dismissed, state.popupTriggered]);

  const dismiss = useCallback(() => {
    update((prev) => ({ ...prev, dismissed: true }));
    setShowPopup(false);
  }, [update]);

  return {
    showPostAddToCartPopup: showPopup,
    dismiss,
    triggerPopup,
  };
};

export default usePostAddToCartPopup;
